module.exports = __webpack_public_path__ + "static/media/HardwareplusIcon.b636d91a.svg";